export enum FormFieldType {
  Input = 'input',
  TextArea = 'textarea',
  Select = 'select',
  Checkbox = 'checkbox',
  RadioGroup = 'radio-group',
  Date = 'date',
  Time = 'time',
  FieldsGroup = 'fields-group',
  Array = 'array',
  DateRange = 'date-range',
  QuestionWithDetails = 'question-with-details',
  OfficeHours = 'office-hours',
  StagedFieldsGroup = 'staged-fields-group',
  File = 'file',
  Login = 'login-field',
  RadioGrid = 'radio-grid',
  CheckboxGroup = 'checkbox-group',
  ConditionalFieldsGroup = 'conditional-fields-group',
}
